import api from "./api";

class UserService {
  getAllStaffs() {
    return api.get("Staffs/GetAllStaffs");
  }
}

export default new UserService();
